import { Grid } from '@material-ui/core';
import QCXFinalCheckboxField from '../../../../../../../shared-components/final-checkbox-field/QCXFinalCheckboxField';
import QCXFinalForm from '../../../../../../../shared-components/final-form/QCXFinalForm';
import QCXFinalTextField from '../../../../../../../shared-components/final-text-field/QCXFinalTextField';
import { required as requiredValidator } from '../../../../../../../utils/validators/field/validator';

export default function QCXOcorrenciaFinalForm({
  isCreate,
  isConsult,
  isUpdate,
  model,
  handleSubmit,
  authInfo = {},
  requiredRoles = [],
  ...restProps
}) {
  return (
    <QCXFinalForm
      isCreate={isCreate}
      isConsult={isConsult}
      isUpdate={isUpdate}
      initialValues={model}
      handleSubmitValues={handleSubmit}
      authInfo={authInfo}
      requiredRoles={requiredRoles}
      {...restProps}
    >
      {() => (
        <>
          <Grid item xs={12}>
            <QCXFinalTextField
              id="text-field-description"
              key="text-field-description"
              label="Descrição"
              name="description"
              maxLength={250}
              validate={requiredValidator}
              disabled={isConsult}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <QCXFinalCheckboxField
              id="notifica-email-field-description"
              key="notifica-email-field-description"
              label="Notifica email"
              name="notificaEmail"
              disabled={isConsult}
              required
            />
          </Grid>
        </>
      )}
    </QCXFinalForm>
  );
}
